<div class="row contact-container">
  <div class="d-block d-md-none">
<h1>{{ 'get_in_touch_help' | translate }}</h1>
    <p>
      {{ "Have questions about pricing" | translate }}
    </p>
  </div>

  <div class="col-12 col-md-6 col-lg-7 left-container order-md-1 order-2">
    <div class="d-none d-md-block">
     <h1>{{ 'get_in_touch_help' | translate }}</h1>
      <p>
        {{ "Have questions about pricing" | translate }}
      </p>
    </div>

    <img width="100%" class="d-none d-md-block contact-img" [src]="contactImage" />

    <p class="mt-4">
      {{ "Have questions about pricing" | translate }}
    </p>

    <div class="d-flex justify-content-between align-items-center contact-info-row">
      <div>
        <i class="bi bi-envelope" *ngIf="emailpath">
          <div class="mx-2 d-inline">{{ emailpath }}</div>
        </i>

        <br />

        <i class="bi bi-telephone">
          <div dir="ltr" class="mx-2 d-inline">{{ whatsappNumber }}</div>
        </i>

        <br />

        <i class="bi bi-geo-alt">
          <div class="mx-2 d-inline">Egypt, Cairo</div>
        </i>
      </div>

<div class="d-flex social">
  <ng-container *ngFor="let link of soicalMediaLinks">
    <a *ngIf="link.name !== 'whatsapp'"
       [href]="link.link || link.path"
       [attr.download]="link.name === 'portfolio' ? 'portfolio.pdf' : null"
       [target]="link.name === 'portfolio' ? '_self' : '_blank'">
      <fa-icon [icon]="icons[link.icon]"></fa-icon>
    </a>
  </ng-container>
</div>
    </div>
  </div>

  <div class="col-12 col-md-6 col-lg-5 p-0 order-md-2 order-1">
    <div class="form-container">
      <form [formGroup]="contactForm" (ngSubmit)="onSubmit()">

        <!-- Full Name -->
        <label>{{ "Full Name" | translate }}</label>
        <div class="input-container mt-1">
          <i class="bi bi-person fs-4 left-icon"></i>
          <input type="text" formControlName="fullName" [placeholder]="'Enter your fullName' | translate" />
        </div>

        <div *ngIf="contactForm.get('fullName')?.touched && contactForm.get('fullName')?.invalid"
          class="validation-message">
          <div *ngIf="contactForm.get('fullName')?.errors?.['required']">
            {{ 'validation.fullName_required' | translate }}
          </div>
          <div *ngIf="contactForm.get('fullName')?.errors?.['pattern']">
            {{ 'validation.fullName_pattern' | translate }}
          </div>
        </div>

        <!-- Phone -->
        <div class="mt-3">
          <label>{{ "Phone Number" | translate }}</label>
          <div class="input-container mt-1">
            <i class="bi bi-telephone fs-5 left-icon"></i>
            <input type="text" formControlName="phoneNumber" [placeholder]="'Enter your phone number' | translate" />
          </div>

          <div *ngIf="contactForm.get('phoneNumber')?.touched && contactForm.get('phoneNumber')?.invalid"
            class="validation-message">
            <div *ngIf="contactForm.get('phoneNumber')?.errors?.['required']">
              {{ 'validation.phone_required' | translate }}
            </div>
            <div *ngIf="contactForm.get('phoneNumber')?.errors?.['pattern']">
              {{ 'validation.phone_pattern' | translate }}
            </div>
            <div
              *ngIf="contactForm.get('phoneNumber')?.errors?.['minlength'] || contactForm.get('phoneNumber')?.errors?.['maxlength']">
              {{ 'validation.phone_length' | translate }}
            </div>
          </div>
        </div>

        <!-- Email -->
        <div class="mt-3">
          <label>{{ "Email" | translate }}</label>
          <div class="input-container mt-1">
            <i class="bi bi-envelope fs-5 left-icon"></i>
            <input type="email" formControlName="email" [placeholder]="'Enter your email' | translate" />
          </div>

          <div *ngIf="contactForm.get('email')?.touched && contactForm.get('email')?.invalid"
            class="validation-message">
            <div *ngIf="contactForm.get('email')?.errors?.['required']">
              {{ 'validation.email_required' | translate }}
            </div>
            <div *ngIf="contactForm.get('email')?.errors?.['email']">
              {{ 'validation.email_invalid' | translate }}
            </div>
          </div>
        </div>

        <!-- Message -->
        <div class="mt-3">
          <label>{{ "Message" | translate }}</label>
          <div class="input-container mt-1">
            <i class="bi bi-chat-left-text fs-5 left-icon area-icon"></i>
            <textarea formControlName="message" [placeholder]="'Enter your message' | translate"></textarea>
          </div>

          <div *ngIf="contactForm.get('message')?.touched && contactForm.get('message')?.invalid"
            class="validation-message">
            <div *ngIf="contactForm.get('message')?.errors?.['required']">
              {{ 'validation.message_required' | translate }}
            </div>
            <div *ngIf="contactForm.get('message')?.errors?.['minlength']">
              {{ 'validation.message_minlength' | translate }}
            </div>
          </div>
        </div>

        <!-- Submit -->
        <button type="submit" class="w-100 py-2 btn mt-3" [disabled]="contactForm.invalid">
          {{ "Send" | translate }}
        </button>
      </form>

      <!-- Divider -->
      <div class="or-divider my-4">
        <div class="line"></div>
        <label>{{ "Or" | translate }}</label>
        <div class="line"></div>
      </div>

      <!-- WhatsApp -->
      <a [href]="whatsappLink" target="_blank">
        <button class="contact-btn py-1">
          <img [src]="whatAppPath" />
          {{ "Contact with us by Whatsapp" | translate }}
        </button>
      </a>
    </div>
  </div>
</div>